import { hasDefaultPortalStatuses } from '../constants/appsWithDefaultStatuses';
export const getAuthorizationStatuses = statuses => {
  return Array.isArray(statuses) ? statuses.filter(({
    metadata: {
      category
    }
  }) => category === 'AUTHORIZATION') : statuses;
};
const getStatusesMapKey = args => `account-${(args === null || args === void 0 ? void 0 : args.externalAccountId) || ''}-${(args === null || args === void 0 ? void 0 : args.businessUnitId) || ''}-${(args === null || args === void 0 ? void 0 : args.userId) || ''}`;
export const getAccountsStatusesMap = statuses => {
  return Array.isArray(statuses) ? statuses.reduce((acc, curr) => {
    const accountKey = getStatusesMapKey(curr);
    if (accountKey in acc) {
      acc[accountKey].push(curr);
    } else {
      acc[accountKey] = [curr];
    }
    return acc;
  }, {}) : {};
};
export const getMostRecentAccountsStatusesList = statuses => {
  var _statuses$;
  const accountsStatusesMap = getAccountsStatusesMap(statuses);
  const appId = statuses === null || statuses === void 0 || (_statuses$ = statuses[0]) === null || _statuses$ === void 0 ? void 0 : _statuses$.appId;
  const mayHaveDefaults = hasDefaultPortalStatuses(appId);
  if (mayHaveDefaults) {
    const defaultPortalKey = getStatusesMapKey();
    const keysCount = Object.keys(accountsStatusesMap).length;
    if (defaultPortalKey in accountsStatusesMap && keysCount > 1) {
      delete accountsStatusesMap[defaultPortalKey];
    }
  }
  const result = Object.values(accountsStatusesMap || {}).reduce((acc, curr) => {
    const sorted = curr.toSorted((s1, s2) => {
      const timestamp1 = Math.max(s1.metadata.createdAt, s1.metadata.updatedAt);
      const timestamp2 = Math.max(s2.metadata.createdAt, s2.metadata.updatedAt);
      return timestamp2 - timestamp1;
    });
    acc.push(sorted[0]);
    return acc;
  }, []);
  return result;
};